import StatusCodes from 'http-status-codes'
import { http, HttpResponse } from 'msw'

import { type Comment } from '@webapp/models/Comment'
import { type IApiV3Response } from '@webapp/services/api'
import { CommentMock } from '@webapp/tests/mocks/comment.factory'

export const getCommentsStub = (response?: Comment[]) => {
  return http.get<undefined, IApiV3Response<Comment[]>>(
    '/api/v3/comments/',
    () => {
      return HttpResponse.json(
        {
          data: response ?? CommentMock.buildList(3),
        },
        { status: StatusCodes.OK }
      )
    }
  )
}
